import SxSocket from '@/api/socket'

export interface storeOptsType {
	modules: any;
	state: any;
	mutations: any;
	actions: any;
	getters: any;
}

export const modules = {

}
export const state = function () {
	return {
		analyzedResult: [],
		acpointValue: [],
		deviceStatus: [],
	}
}
export const mutations = {
	subscribeData(state) {
		state.socketClient?.disconnect()
		state.socketClient = null
		let socket = SxSocket()
		socket.then((res: any) => {
			state.socketClient = res
			// console.log('订阅数据触发--------------------------', res, res.counter)
			//获取socket对象
			res?.subscribe('/exchange/platform/#', async (res) => {
				const body = JSON.parse(res.body)
				switch (body.action) {
					//订阅隐患推送
					case 'patrol.result.analyzed':
						const { action, ...others } = body
						state.analyzedResult = others;
						break
					case 'front.acpoint.value':
						state.acpointValue = body.data;
						break
					case 'front.acdevice.status':
						state.deviceStatus = body.data;

				}
			})
		})
	},
}
export const actions = {
	subscribeData(obj) {
		obj.commit('subscribeData')
	},
}
export const getters = {

}
export const storeOpts: storeOptsType = {
	modules,
	state,
	mutations,
	actions,
	getters,
}
